export class Model_CRM_Segments
{
    public  SegmentId : number;
    public  Segmentname : string;   
  
}